import { ContentPane } from "@/components/ContentPane.tsx";
import { SectionHeader } from "@/components/SectionHeader.tsx";
import { MetricsGrid } from "@/modules/compute/MetricsGrid.tsx";
import { Trans } from "@lingui/react/macro";
import type { ManagedServicesVmBody } from "@warrenio/api-spec/spec.oats.gen";
import { notNull } from "@warrenio/utils/notNull";

export function MetricsContent({ vms }: { vms: ManagedServicesVmBody[] }) {
    return (
        <ContentPane className="VStack gap-4">
            <SectionHeader title={<Trans>Metrics</Trans>} />

            {vms.map(({ resource_allocation, resource_id, resource_location }, index) => (
                <div key={resource_id} className="VStack gap-2">
                    {vms.length > 1 && (
                        <h3 className="font-size-default">
                            <Trans>Node</Trans> {index + 1}
                        </h3>
                    )}
                    <MetricsGrid
                        vm={{
                            uuid: resource_id,
                            location: notNull(resource_location, "location"),
                            status: resource_allocation.status ?? "stopped",
                        }}
                    />
                </div>
            ))}
        </ContentPane>
    );
}
